<div *ngIf="field.multiple || (!field.multiple&&uploadedMedia?.length == 0)" @fadeIn class="attachment">
  <div class="attach-button">
    <!-- <a style="color: #1A405D; font-weight: 600; cursor: pointer" (click)="showAttachment()">View Attached Attachment</a> -->
    <button (click)="inputFile.click()" class="attach-button" color="default"
            mat-raised-button style="width:100%; height: 45px; margin-top: 5px" title="Upload associated file"
            type="button">
      <mat-icon>attach_file</mat-icon>
      <span *ngIf="fileUploadedName; else weHaveFile"> {{ fileUploadedName }}</span>
      <ng-template #weHaveFile> {{ field?.label }}</ng-template>
    </button>
    <input #inputFile (change)="onFileSelected($event)" [accept]="accept" [multiple]="field.multiple"
           hidden type="file"/>
  </div>
</div>
<div *ngIf="uploadedMedia.length > 0" @fadeIn class="media-upload-table-container">
  <h4 class="text-gray-500 text-sm font-semibold mt-3 no-underline">Attachment(s)</h4>
  <table class="w-full text-sm text-left text-gray-500">
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
    <tr>
      <th style="width: 246px"></th>
      <th style="width: 200px"></th>
      <th style="width: 100px;"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let media of uploadedMedia; let i = index"
        class="bg-white">
      <td>
        <div class="flex flex-row items-center">
<!--          <div *ngIf="media.isImage"-->
<!--               [ngClass]="{'blur-sm' :media.fileProgress<100, 'blur-none' :media.fileProgress ==100  }"-->
<!--               style="margin-right: 8px;">-->
<!--            <img [src]="media.fileUrl  | safeHtml" alt="Photo" height="120px" width="120px">-->
<!--          </div>-->
          <div class="text-xs hover:font-bold cursor-pointer">
              <span style="word-wrap: break-word; white-space: pre-line">
                {{ media.fileName }}
              </span>
          </div>
        </div>
      </td>
      <td class="align-middle">
        <div class="flex flex-col w-full" style="margin-top: 18px;">
          <div class="w-full rounded-full ">
            <div [style.width.%]="media.fileProgress"
                 class="text-xs font-medium text-center p-0.5 rounded-full  bg-primary-400 text-white"
            > {{ media.fileProgress }}%
            </div>
          </div>
          <div class="text-center text-xs">
            {{ media.fileProgessSize }} of {{ media.fileSize }}
          </div>
        </div>
      </td>
      <td class="align-middle items-center">
        <button type="button" (click)="openFile(media)" *ngIf="media?.isPdf" class="!bg-green-500 !flex !items-center !justify-center !h-7 !w-7 !text-white !shadow-sm me-1" mat-mini-fab>
          <mat-icon svgIcon="view" class="!h-4 !w-4"></mat-icon>
        </button>

        <button type="button" (click)="removeImage(i)" *ngIf="media.fileProgress === 100" @fadeIn
                class="!bg-red-100 !flex !items-center !justify-center !h-7 !w-7 !text-red-500 !shadow-sm me-1"
                mat-mini-fab>
          <mat-icon svgIcon="delete" class="!h-4 !w-4"></mat-icon>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
